<div class="granularity-selection">
  <label>{{ 'module.shared.excelDownloadWizard.granularityLabelText' | translate }}:</label>

  <mat-radio-group class="radio-group" aria-labelledby="radio-group-label" [(ngModel)]="filter.granularity">
    <mat-radio-button *ngFor="let option of granularityOptions" [value]="option" (change)="onSelectionChange(option)">
      {{ granularityEnum[option] }}
    </mat-radio-button>
  </mat-radio-group>
</div>
